var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.9995,
    r: 15,
    fill: "#406EE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7855 9.53534C22.4284 9.17819 21.857 9.21391 21.4998 9.57105L13.357 18.5353L8.39268 14.6068C7.99982 14.2853 7.42839 14.3568 7.10697 14.7496C6.78554 15.1425 6.85697 15.7139 7.24982 16.0353L12.8927 20.5353C13.2855 20.8211 13.8213 20.7853 14.1427 20.4282L22.857 10.8211C23.2141 10.4639 23.1784 9.85677 22.7855 9.53534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.9b4dc77ba96327f56d8b51a3260b7e7a.svg";
export { ForwardRef as ReactComponent };